<template>
    <Gallery v-if="element.type=='DNL-GALLERY'" v-bind:imgs="element.imgs" v-bind:title="element.title"></Gallery>

    <SimpleHtmlElement v-else :element="element"></SimpleHtmlElement>
</template>

<script>
import SimpleHtmlElement from './embeds/SimpleHtmlElement.vue';
import Gallery from './embeds/Gallery.vue';

export default {
    name: "ArticleElement",
    components: {
        Gallery,
        SimpleHtmlElement
    },
    props: {
        element: Object
    }
}

</script>

<style>
iframe{
    width: 100%;
}

figure a{
    display: block;
}

figure a, .content figure{
    max-height: 107px;
    max-width: 150px;
}

dnl-instagramembed{
    max-width: 450px;
    display: block;
    margin: 30px auto;
}

dnl-dwchart, div.gallery{
    margin: 30px auto 30px;
}

div.gallery{
    padding-bottom: 0;
}

dnl-box h2{
    font-size: 16px;
}

dnl-image{
    font-size: 1em;
}

.content p:not(:last-child), 
dnl-quote, 
dnl-wgchart, 
dnl-dwchart, 
dnl-liveblog, 
dnl-image, 
dnl-box{
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>